import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as connectedReactRouter from 'connected-react-router'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import HeaderExternalLayout from '../../commons/HeaderExternalLayout/HeaderExternalLayout'
import RegisterPhoneForm from './RegisterPhoneForm'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'

const RegisterEmailContainer = () => {
  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(
      reducks.resources.users.actions.registerUserReceiveData(data, 'password')
    )

  useEffect(() => {
    const requirements = ['cnpj', 'email']
    dispatch(
      reducks.resources.users.actions.registerUserRequirements(
        requirements,
        routes.registerEmail.path
      )
    )
  }, [])

  const initialValues = { phoneNumberCell: '' }

  const back = () =>
    dispatch(connectedReactRouter.routerActions.push(routes.registerEmail.path))

  return (
    <ExternalLayout>
      <HeaderExternalLayout
        title="Amplie sua presença e resultados."
        subtitle="Atue com eficiência e visão estratégica, acompanhe o seu cliente
        diariamente e aumente os seus ganhos."
      />
      <RegisterPhoneForm
        handleSubmit={handleSubmit}
        initialValues={initialValues}
        back={back}
      />
    </ExternalLayout>
  )
}

export default RegisterEmailContainer
